<template>
  <el-dialog v-model="showProxy" fullscreen draggable :title="$str.getKey('数据分析/查看拓扑')" @confirm="onConfirm"
    @cancel="handleClose" :before-close="handleClose" class="view-topo-modal dialog-container">
    <template #header>
      <div class="header-container">
        <div class="icon-container"></div>
        <span class="title-text">{{ $str.getKey('数据分析/查看拓扑') }}</span>
      </div>
    </template>

    <div class="modal-container">
      <TopoGraph></TopoGraph>
    </div>

    <template #footer>
      <el-button @click="handleClose" class="custom-cancel-btn">{{ $str.getKey('数据分析/关闭') }}</el-button>
    </template>
  </el-dialog>
</template>
<script setup>
import { defineEmits, defineOptions, defineProps } from "vue";
import { useVModel } from "@vueuse/core";
import TopoGraph from "./topoGraph/index.vue"; // 拓扑图

const $str = window.$str;

/** 设置组件配置项 */
defineOptions({
  name: "viewTopoModal"
});

/** 接收父组件信息 */
const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  stationId: [Number, String]
});

const emit = defineEmits(['update:show', 'SendChange']);
const showProxy = useVModel(props, "show", emit);
function onConfirm() { }
function handleClose() { emit("SendChange", false); }

</script>


<style lang="scss" scoped>
.view-topo-modal {
  .header-container {
    display: flex;
    align-items: center;
    padding-left: 20px;
    height: 50px;

    .icon-container {
      width: 29px;
      height: 29px;
      background-image: radial-gradient(#FFF 5%, #3a68ff 30%);
      border-radius: 4px;
      border: 1px solid #3a68ff;
      transform: rotate(45deg);
      margin-right: 20px;
    }

    .title-text {
      font-family: 'HarmonyOS Sans SC', sans-serif;
      font-weight: 500;
      font-size: 18px;
      color: #2e2e2e;
      text-align: center;
      letter-spacing: 1px;
    }
  }

  .modal-container {
    height: 100%;
    display: flex;
    padding: 24px;
    box-sizing: border-box;
    background: #FFFFFF;
  }

  .custom-cancel-btn {
    border: 1px solid rgba(192, 207, 218, 0.3) !important;

    &:hover {
      background: #f5f7fa !important;
      color: #2e2e2e !important;
    }

    &:active {
      background: #f5f7fa !important;
    }
  }
}
</style>
